import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useScheduleTable from './useScheduleTable';
import { RoomSchedule, RoomV2 } from 'type/room';
import { orderMeeting, setMeetingOrderParams } from 'model/meeting';
import { IMeetingOrderFn, IMeetingOrderForm } from 'type/meeting';
import { useDispatch } from 'react-redux';
import { IMeetingDetail } from 'type/meetingDetail';
import tracker from 'lib/tracker';
import { cloneDeep } from 'lodash-es';

const RoomScheduleTable: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { componentRef, setBlinkList, emitScheduleChange } = useScheduleTable();

  /** 点击会议室 */
  const onClickRoom = ({ detail }: { detail: [RoomV2] }) => {
    tracker?.reporteMeetingRoom('查看会议室议程');
    const [room] = detail;
    history.push(`/room-detail/${room.id}`);
  };

  /** 点击预约 */
  const onConfirm: IMeetingOrderFn = (meeting) => {
    tracker?.reporteMeetingRoom('预约会议');
    return new Promise((resolve) => {
      dispatch(
        orderMeeting({
          meeting,
          onSuccess: (meeting: IMeetingDetail) => {
            emitScheduleChange();
            setBlinkList(meeting.roomOrderList?.map((room) => room.orderNo) || []);
            resolve({ success: true });
          },
          onFail: (err: any) => {
            if (err?.response?.data?.code === 400403002) {
              const data = err?.response?.data?.data;
              resolve({ success: false, data: data });
            } else if (err?.response?.data?.code === 400406011) {
              resolve({ success: false, errMesaage: '预约人（部门）、会议主题、会议地点可能包含涉黄/涉暴/政治/敏感信息，请检查后重试' });
            } else {
              resolve({ success: false, data: null });
            }
          },
          redirect: false
        })
      );
    });
  };

  /** 点击预约表单-更多 */
  const onClickOrderMore = (form: IMeetingOrderForm) => {
    tracker?.reporteMeetingRoom('会议室-点击预约表单-更多');
    dispatch(setMeetingOrderParams(cloneDeep(form)));
    history.push('/order-meeting');
  };

  /** 点击日程 */
  const onClickOrderSchedule = ({ detail }: { detail: [RoomSchedule] }) => {
    tracker?.reporteMeetingRoom('查看会议详情');
    const [roomSchedule] = detail;
    history.push({ pathname: '/details/' + roomSchedule.meetingNo });
  };

  const onHeaderConditionChange = (value: any) => {
    const [ov, type] = value?.detail || ['', ''];
    switch (type) {
      case 'dateLast':
      case 'dateNext':
      case 'datePikcer':
        tracker?.reporteMeetingRoom('切换日期');
        break;
      case 'roomNameSearch':
        tracker?.reporteMeetingRoom('搜索会议室');
        break;
      case 'roomCascaderChange':
        tracker?.reporteMeetingRoom('选择会议室');
        break;
      default:
        break;
    }
  };

  /** 属性设置、事件回调监听 */
  useEffect(() => {
    if (!componentRef.current) return;

    componentRef.current.confirm = onConfirm;
    componentRef.current.clickMore = onClickOrderMore;

    // 初始化-监听事件
    componentRef.current?.addEventListener('click-room', onClickRoom);
    componentRef.current?.addEventListener('click-schedule-detail', onClickOrderSchedule);
    componentRef.current?.addEventListener('on-header-condition-change', onHeaderConditionChange);

    // 卸载时-清除监听
    return () => {
      componentRef.current?.removeEventListener('click-room', onClickRoom);
      componentRef.current?.removeEventListener('click-schedule-detail', onClickOrderSchedule);
      componentRef.current?.removeEventListener('on-header-condition-change', onHeaderConditionChange);
    };
  }, []);

  return (
    <>
      <div style={{ width: '100%', height: '100%', margin: 'auto' }}>
        <ce-room-schedule theme="client" ref={componentRef} />
      </div>
    </>
  );
};

export default RoomScheduleTable;
